define(function (require) {
    "use strict";

    var template = require("personalization-web-agent-templates/widget-templates/widget-organize/widgetOrganizeItemView.tmpl");

    var Button = require("ui/button/Button");
    var ICON_PREFIX = "widget-icon-";

    var WidgetOrganizeItemView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetOrganizeItemView = Marionette.ItemView.extend({
            template: template,
            tagName:"tr",
            ui:{
                widgetIcon: ".widget-symbol",
                moveTop: ".actions-movetop",
                moveUp: ".actions-moveup",
                moveDown: ".actions-movedown",
                moveBottom: ".actions-movebottom",
                itemContainer: ".widget-organize-item-container"
            },
            uiComponents: {

            },
            events: {
                "click .actions-movetop": "_onMoveTopClick",
                "click .actions-moveup": "_onMoveUpClick",
                "click .actions-movedown": "_onMoveDownClick",
                "click .actions-movebottom": "_onMoveBottomClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing WidgetOrganizeItemView", "WidgetOrganizeItemView:initialize");
                this.vent = options.vent;
            },

            /************************** public functions *****************************************************/

            customTemplateHelpers: function () {
                var widgetName = this.model.getName();
                var isCoreWidget = this.model.isCoreWidget();
                return {
                    title : isCoreWidget ? "" :  this.model.getWidgetInitials(),
                    widgetName: isCoreWidget ? LE.translator.translate("LEPersonalization.webAgent.widget.widgetName." + widgetName) : widgetName,
                    iconType: isCoreWidget ? ICON_PREFIX + widgetName : ""
                };
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering WidgetOrganizeItemView", "WidgetOrganizeItemView:onRender");
                this._initWidgetIconState();
                this._toggleReorderButtons(this.model.getOrder());
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetOrganizeItemView", "WidgetOrganizeItemView:onClose");
            },

            /************************** private functions *****************************************************/

            _initWidgetIconState: function(){
                this.ui.widgetIcon.toggleClass("hidden-widget", !this.model.isEnabled());
                this.ui.widgetIcon.toggleClass("pilot-widget", this.model.isPilotMode());
                this.ui.widgetIcon.toggleClass("core-widget", this.model.isCoreWidget());
                this.ui.itemContainer.toggleClass("unsupported", !LE.crossModule("webagent", LE.media.actions.request, LE.mediaCodes.webAgent.reqres.isWidgetConfigurable, this.model.getName()));
            },

            _onMoveTopClick: function() {
                if(this.model.getOrder() > 1) {
                    this.vent.trigger("widget-organize:change:order:movetop", this, this.model);
                }
            },
            _onMoveUpClick: function() {
                if(this.model.getOrder() > 1) {
                    this.vent.trigger("widget-organize:change:order:moveup", this, this.model);
                }
            },
            _onMoveDownClick: function() {
                if(this.model.getOrder() < this.model.collection.size()) {
                    this.vent.trigger("widget-organize:change:order:movedown", this, this.model);
                }
            },
            _onMoveBottomClick: function() {
                if(this.model.getOrder() < this.model.collection.size()) {
                    this.vent.trigger("widget-organize:change:order:movebottom", this, this.model);
                }
            },
            _toggleReorderButtons: function(order) {
                this.ui.moveUp.toggleClass("disabled", order === 1);
                this.ui.moveTop.toggleClass("disabled", order === 1);
                this.ui.moveDown.toggleClass("disabled", order === this.model.collection.size());
                this.ui.moveBottom.toggleClass("disabled", order === this.model.collection.size());
            }
        });
    });
    return WidgetOrganizeItemView;
});

